export default "__VITE_ASSET__Bhp4_7Ak__"